import {AManagerApi} from "@/classes/app/api/manager/a-manager-api";

export default class OwnerInfoNotify extends AManagerApi {
    protected _url: string = '/owner/info/notify';
}
